import { render, staticRenderFns } from "./video.vue?vue&type=template&id=125bda31&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
import style0 from "./video.vue?vue&type=style&index=0&id=125bda31&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125bda31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125bda31')) {
      api.createRecord('125bda31', component.options)
    } else {
      api.reload('125bda31', component.options)
    }
    module.hot.accept("./video.vue?vue&type=template&id=125bda31&scoped=true", function () {
      api.rerender('125bda31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/video.vue"
export default component.exports